import React from 'react';
import { MackAcquisitionView } from '../../lib/mackAcquisitionView';
import { card, panelTitle, panelNote } from './primitives';
import { C } from './tokens';

export function AcquisitionEvidence({ view, state, sheet }: {
  view: MackAcquisitionView | null; state: 'loading' | 'ready' | 'unavailable'; sheet?: string;
}) {
  const rows = view?.rows.filter(row => !sheet || row.sheet === sheet) || [];
  return <section aria-label="Acquired official evidence" style={{ ...card, padding: 20 }}>
    <div style={panelTitle}>Acquired official evidence</div>
    <p style={panelNote}>Raw observations and source dates. Downstream calculations remain disabled.</p>
    {state === 'loading' && <p>Loading evidence…</p>}
    {state === 'unavailable' && <p>Evidence could not be verified for this view.</p>}
    {state === 'ready' && rows.length === 0 && <p>No acquired evidence is available for this view.</p>}
    {state === 'ready' && rows.map(row => <article key={row.record_id} data-record-id={row.record_id}
      data-record-sha256={row.record_sha256} style={{ borderTop: `1px solid ${C.rule}`, paddingTop: 12, marginTop: 12 }}>
      <strong>{row.identity}</strong>
      <p>{row.sheet} · {row.block} · Period {row.period} · Vintage {row.vintage}</p>
      {row.raw_value !== null && <p>{row.raw_value}{row.unit ? ` ${row.unit}` : ''}</p>}
      <p>Published {row.published_at || 'unavailable'}{row.scheduled_at ? ` · Scheduled ${row.scheduled_at}` : ''}</p>
      <p>{row.excerpt}</p>
      <a href={row.source_url} target="_blank" rel="noopener noreferrer">{row.publisher}</a>
    </article>)}
  </section>;
}
